import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { PhotoGrid } from "@/components/gallery/PhotoGrid";
import { useGallery } from "@/hooks/useGallery";

export default function GalleriaPreview() {
    const { photos } = useGallery();
    const preview = (photos || []).slice(0, 6);
    if (photos && photos.length === 0) return null;

    return (
        <section id="galleria" data-testid="galleria-preview-section" className="bg-tl-dark py-20 md:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
                <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
                    <div>
                        <Reveal>
                            <Eyebrow number="04" label="Galleria" />
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h2 className="mt-6 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
                                I nostri lavori<span className="text-tl-orange">.</span>
                            </h2>
                        </Reveal>
                    </div>
                    <Reveal delay={0.15}>
                        <Link
                            to="/galleria"
                            data-testid="galleria-preview-cta"
                            className="group inline-flex items-center gap-3 border border-white/20 px-6 py-3 font-mono-tl text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:border-tl-orange hover:text-tl-orange"
                        >
                            Vedi tutte le foto
                            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                        </Link>
                    </Reveal>
                </div>
                <div className="mt-14">
                    {photos === null ? (
                        <div className="grid auto-rows-[240px] grid-cols-1 gap-3 sm:grid-cols-3 lg:grid-cols-4">
                            {[...Array(4)].map((_, i) => (
                                <div key={i} className="animate-pulse bg-tl-card" />
                            ))}
                        </div>
                    ) : (
                        <PhotoGrid photos={preview} />
                    )}
                </div>
            </div>
        </section>
    );
}
